<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>espectaculares</title>
      <path fill="#679940"
        d="M27.9,1H4.1a1,1,0,0,0-1,1V16a1,1,0,0,0,1,1h6.56l4.59,3.28V31h2V20.28L21.83,17H27.9a1,1,0,0,0,1-1V2A1,1,0,0,0,27.9,1ZM16.25,18.53,14.1,17h4.29ZM26.9,15H5.1V3H26.9Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "EspectacularesIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/EspectacularesIcon.vue